import { html } from 'lit-html';
import { readVersionFromPackage } from '../utils/version.js';
import { themeService } from '../services/theme.js';
import { t } from '../i18n/index.js';

// Componente de rodapé da aplicação
// rightContent: conteúdo HTML opcional para o lado direito do footer
export const appFooter = (rightContent = null) => {
  const version = readVersionFromPackage();
  const currentTheme = themeService.getTheme();

  return html`
    <footer class="app-footer">
      <div class="footer-content">
        <div class="footer-left">
          <div class="top-row">
            <div class="app-name">
              <img src="${currentTheme === 'dark' ? '/images/logo_white.png' : '/images/logo_black.png'}" alt="SummDash" class="logo-main">
            </div>
            <span class="version">${version}</span>
          </div>
          <div class="powered-by-content">
            <span class="powered-text">${t('footer.poweredBy')}</span>
            <img src="${currentTheme === 'dark' ? '/images/logo_summ_white.png' : '/images/logo_summ_black.png'}" alt="Summ Digital" class="powered-logo">
          </div>
        </div>
        ${rightContent ? html`<div class="footer-right">${rightContent}</div>` : ''}
      </div>
    </footer>
    
    <style>
      .app-footer {
        background: rgba(255, 255, 255, 0.7);
        backdrop-filter: blur(20px) saturate(180%);
        -webkit-backdrop-filter: blur(20px) saturate(180%);
        border-top: 1px solid rgba(255, 255, 255, 0.3);
        box-shadow:
          0 -4px 16px 0 rgba(31, 38, 135, 0.1),
          inset 0 1px 1px 0 rgba(255, 255, 255, 0.8);
        padding: 16px 0;
        margin-top: auto;
        flex-shrink: 0;
      }

      [data-theme="dark"] .app-footer {
        background: rgba(30, 30, 30, 0.6);
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow:
          0 -4px 16px 0 rgba(0, 0, 0, 0.3),
          inset 0 1px 1px 0 rgba(255, 255, 255, 0.1);
      }
      
      .footer-content {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
      }
      
      @media (max-width: 768px) {
        .footer-content {
          flex-direction: column;
          text-align: center;
          gap: 8px;
        }
      }
      
      .footer-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        width: 100%;
      }
      
      .top-row {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      
      .app-name {
        display: flex;
        align-items: center;
      }
      
      .app-name img.logo-main {
        height: 18px;
        width: auto;
        display: inline-block;
      }

      @media (max-width: 480px) {
        .footer-left {
          order: 1;
        }
        
        .footer-center {
          order: 3;
        }
        
        
        .footer-content {
          gap: 6px;
        }
        
      }
      
      .version {
        background: var(--summdash-gradient);
        color: white;
        padding: 3px 8px;
        border-radius: 12px;
        font-size: 11px;
        font-weight: 500;
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        position: relative;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(24, 119, 242, 0.2);
        transition: all 0.3s ease;
      }
      
      .version::before {
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        right: -1px;
        bottom: -1px;
        border-radius: 13px;
        background: linear-gradient(45deg, rgba(24, 119, 242, 0.3), rgba(66, 184, 131, 0.3), rgba(24, 119, 242, 0.3));
        background-size: 200% 200%;
        z-index: -1;
        opacity: 0;
        animation: subtle-glow 4s ease-in-out infinite;
      }
      
      .version:hover::before {
        opacity: 1;
      }
      
      @keyframes subtle-glow {
        0%, 100% {
          background-position: 0% 50%;
          opacity: 0;
        }
        50% {
          background-position: 100% 50%;
          opacity: 0.6;
        }
      }
      
      .powered-by-content {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        opacity: 0.5;
      }
      
      .powered-text {
        font-size: 12px;
        color: var(--text-muted);
        font-weight: 500;
      }
      
      .powered-logo {
        height: 14px;
        width: auto;
      }

      .footer-right {
        display: flex;
        align-items: center;
        gap: 16px;
      }

      @media (max-width: 768px) {
        .app-footer {
          /* Espaço para o menu de navegação mobile fixo */
          margin-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
        }

        .footer-right {
          width: 100%;
          justify-content: center;
          flex-wrap: wrap;
          gap: 8px;
        }
      }

    </style>
  `;
};